import { useTranslation } from 'next-i18next'

import HoMCard from '~/components/HoMCard'
import PanelContactCard from '~/panels/components/PanelContactCard'
import { parsePhoneNumberWithCallingCode } from '~/utils/helpers'

export default function StudentTutorItem({
  avatarPngUrl,
  description,
  email,
  fullName,
  institute,
  phone,
}: {
  avatarPngUrl: string | null
  description: string | undefined
  email: string | null
  fullName: string | null
  institute: string | undefined
  phone: string | null
}): React.ReactElement {
  const { t } = useTranslation('studentPanel')
  const phoneNumber = parsePhoneNumberWithCallingCode(phone)

  return (
    <div className="w-max max-w-full mx-auto space-y-4 flex flex-col">
      <HoMCard bio={description} education={institute} imageSrcKey={avatarPngUrl} name={fullName} />
      <PanelContactCard email={email} header={t('tutorContactInfo')} isAlwaysColumn phoneNumber={phoneNumber} />
    </div>
  )
}
